import React, { useMemo, useState } from "react";
import "../css/privacy-policy.css";
import PrivacyPolicy from "./PrivacyPolicy";
import PreventChildAbuse from "./PreventChildAbuse";
import WebsiteTermsOfUse from "./WebsiteTermsOfUse";

const tabs = [
  { id: "privacy", label: "Privacy Notice", component: <PrivacyPolicy /> },
  { id: "terms", label: "Terms of Use", component: <WebsiteTermsOfUse /> },
  {
    id: "child-safety",
    label: "Preventing Child Sexual Abuse",
    component: <PreventChildAbuse />,
  },
];

const TermsAndConditions = () => {
  const [activeTab, setActiveTab] = useState("privacy");

  const activeContent = useMemo(
    () => tabs.find((tab) => tab.id === activeTab)?.component ?? null,
    [activeTab]
  );

  return (
    <div className="legal-page">
      <header className="legal-page__header">
        <div className="legal-page__container">
          <div className="legal-page__topbar">
            <a className="legal-page__brand" href="/">
              <img src={require("../images/logo.svg").default} alt="Cling" />
            </a>
            <div className="legal-page__links">
              <a href="/">Home</a>
              <a href="/UserAccountDelete">Delete Account</a>
              <a
                href="https://play.google.com/store/apps/details?id=com.cling1.app"
                target="_blank"
                rel="noreferrer"
              >
                Download App
              </a>
            </div>
          </div>

          <div className="legal-page__intro">
            <p className="legal-page__eyebrow">Policies and Safety</p>
            <h1>Website legal information for Cling</h1>
            <p>
              This section includes the current website privacy notice, terms of use, and the
              mandatory child safety policy that remains visible on the site. Cling™ is a product
              of ClubIn Platforms Pvt. Ltd., an India-based company.
            </p>
          </div>

          <div className="legal-page__tabs" role="tablist" aria-label="Legal tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={activeTab === tab.id ? "active" : ""}
                onClick={() => setActiveTab(tab.id)}
                type="button"
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </header>

      <main className="legal-page__body">
        <div className="legal-page__container">{activeContent}</div>
      </main>
    </div>
  );
};

export default TermsAndConditions;
